import { render, staticRenderFns } from "./OverlayError.vue?vue&type=template&id=721e225c&scoped=true"
import script from "./OverlayError.vue?vue&type=script&lang=ts"
export * from "./OverlayError.vue?vue&type=script&lang=ts"
import style0 from "./OverlayError.vue?vue&type=style&index=0&id=721e225c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721e225c",
  null
  
)

export default component.exports